import { FC } from 'react';
import keyBy from 'lodash/keyBy';
import Image from 'next/image';

import { JobTypeField } from 'modules/job-types/types';

import styles from './BusinessRequestFormEntry.module.scss';

interface Props {
  firstField: JobTypeField;
  onSubmit: (corporateindividual: string) => void;
  title: string;
}

const BusinessRequestFormEntry: FC<Props> = ({ firstField, title, onSubmit }) => {
  const options = ['corporate', 'individual'];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const corporateindividualFieldOptions = keyBy(firstField.options, 'value');

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.buttons}>
        {options.map((option) => {
          const curOption = corporateindividualFieldOptions[option];
          return (
            <>
              <button
                key={`form-entry-business-btn-${option}`}
                className={styles['form-entry-button']}
                onClick={() => onSubmit(option)}
              >
                <div className={styles['button-body']}>
                  <div className={styles['image-container']}>
                    <Image
                      alt="label"
                      src={`/static/images/icons/business-request-${option}-icon.svg`}
                      width="48"
                      height="48"
                    />
                  </div>
                  <div className={styles['form-entry-button-text']}>{curOption.label}</div>
                </div>
              </button>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default BusinessRequestFormEntry;
